import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { AddRolePageContent } from "Components/Roles/AddRolePageContent";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const PAGE_RESOURCES = Resources.Pages.Titles;

export const AddRolePage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(PAGE_RESOURCES.AddRole)}
      backNavigation={{ mode: "historyStack", fallbackUrl: appUrl("homepage") }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <AddRolePageContent />
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
